import React from "react";
import "./BubblePaneStatic.css";


export default function BubblePane(props) {

    // Find the sizes of each object by converting year/months length to size
    const scaleFactor = 5;
    for (let i = 0; i < props.skills.length; i++) {
        const words = props.skills[i].length.split(" ");
        let num_months = parseFloat(words[0]);
        if (words[1] === "yr") {
            num_months *= 12;
        } // else the type is "mo" and doesn't need converting
        if (num_months < 12) {
            // Set a min size we can't go below
            num_months = 12;
        }
        props.skills[i].diameter = num_months * scaleFactor;
        props.skills[i].radius = props.skills[i].diameter / 2;
        // console.log(props.skills[i].length);
        // console.log(props.skills[i].size);
    }

    // Find the positions of each bubble
    const MAX_HEIGHT = 500;
    const MAX_WIDTH = 800;
    for (let bubbleIdx = 0; bubbleIdx < props.skills.length; bubbleIdx++) {

        console.log("Finding a spot for bubbleIdx", bubbleIdx, " ", props.skills[bubbleIdx]["name"]);

        // Start from the left, check each row slot in a column before moving to the next column
        let foundSpace = false;
        // newX, newY is the center of the circle
        for (let newX = props.skills[bubbleIdx].radius; newX < MAX_WIDTH - props.skills[bubbleIdx].radius && foundSpace === false; newX += 20) {
            for (let newY = props.skills[bubbleIdx].radius; newY < MAX_HEIGHT - props.skills[bubbleIdx].radius && foundSpace === false; newY += 20) {

                console.log("Testing (center) X,Y", newX, newY);
                // Check if this x,y position doesn't interfere with any other already-slotted circles
                foundSpace = true;
                for (let targetBubbleIdx = 0; targetBubbleIdx < bubbleIdx; targetBubbleIdx++) {
                    // console.log("checking against bubbleIdx", targetBubbleIdx);
                    const srcRadius = props.skills[bubbleIdx].radius;
                    const tgtRadius = props.skills[targetBubbleIdx].radius;
                    // Move this the topleft x,y to the center points
                    const deltaX = (props.skills[targetBubbleIdx].x) - (newX);
                    const deltaY = (props.skills[targetBubbleIdx].y) - (newY);
                    const distance = Math.sqrt((deltaX * deltaX) + (deltaY * deltaY));
                    const radii_sum = srcRadius + tgtRadius;
                    console.log("checking against bubbleIdx", targetBubbleIdx, deltaX, deltaY, distance, radii_sum);

                    // This distance is no good, we overlap another bubble
                    if (distance <= radii_sum) {
                        console.log("found collision at", newX, ",", newY, " given a distance away of", distance, "and radii_sum of", radii_sum);
                        foundSpace = false;
                        break;
                    }
                }

                if (foundSpace) {
                    console.log("found open spot at", newX, newY, "with radius", props.skills[bubbleIdx].radius);

                    props.skills[bubbleIdx]["x"] = newX;
                    props.skills[bubbleIdx]["y"] = newY;
                }

            }
        }

    }



    // const positioned_objects = props.skills.map((skill, i) => {
    //     return (
    //         {
    //             name: skill.name,
    //             size: skill.size,
    //             class: skill.class,
    //             length: skill.length,
    //             x: 0 + (100 * i),
    //             y: 0
    //         }
    //     )
    // });


    console.log(props.skills);



    // Create the children objects to display
    const children = props.skills.map((skill, i) => {
        //return <Child data={skill} className="child" key={i}/>
        return (
            <div className={"skill_bubble " + skill.class} key={i} style={{width: skill.diameter +'px', height: skill.diameter +'px', left: skill.x - skill.radius +'px', top: skill.y - skill.radius +'px'}}>
                <div>
                    <h3 style={{fontSize: skill.diameter * 0.15 + "pt"}}>{skill.name}</h3>
                    <h4 style={{fontSize: skill.diameter * 0.1 + "pt"}}>{skill.length}</h4>
                </div>
            </div>
        )
    });

    return (<div id="bubble-pane">
        {children}
    </div>)
}